import classNames from "classnames"
import React from "react"

import TextButton from "@components/elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"
import LayoutItem from "@components/V2/Layouts/LayoutItem"
import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  iconUrl?: string
  iconAlt?: string
  heading: string
  description: React.ReactNode
  linkText?: string
  linkUrl?: string
}

const IntroInfoCard = ({
  iconUrl,
  iconAlt,
  heading,
  description,
  linkText,
  linkUrl,
}: Props) => {
  return (
    <LayoutItem
      as="div"
      className={classNames(
        getBackgroundColorClass(Color.Coal),
        "col-span-full flex flex-col rounded-24 p-24 max-md:pb-40 md:col-span-2 lg:col-span-4 lg:p-32"
      )}
    >
      {iconUrl && (
        <GatsbyStoryblokImage
          image={iconUrl}
          alt={iconAlt || ""}
          height={46}
          width={46}
          className="mb-24"
        />
      )}
      <Typography
        text={heading}
        color={Color.White}
        size="lead-sm"
        weight="medium"
        font="grotesk"
        className="mb-16"
      />
      <div
        className={classNames(
          "text-responsive-body-md gap-4 text-white [&_ul]:list-[inherit] [&_ul]:!p-0",
          { "mb-48": linkText && linkUrl }
        )}
      >
        {description}
      </div>
      {linkText && linkUrl && (
        <TextButton
          text={linkText}
          linkUrl={linkUrl}
          style="icon"
          textSize="body-lg-fixed"
          icon={<ArrowIcon />}
          color={Color.Blue}
        />
      )}
    </LayoutItem>
  )
}

export default IntroInfoCard
